module.exports = __webpack_public_path__ + "img/function.d41279a5.png";